/* common drawer for custom site features (not related to the original cart drawer element) */
class CommonCloseButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('common-drawer').close();
    });
  }
}

customElements.define('common-close-button', CommonCloseButton);

class CommonDrawer extends HTMLElement {
  constructor() {
    super();
    this.triggers = document.querySelectorAll(`.common-drawer-trigger[data-drawer="${this.id}"]`);
    this.contentWrapper = this.querySelector('.common-drawer__body');

    this.contentLoadedOnce = false;

    this.onBodyClick = this.handleBodyClick.bind(this);
    this.addEventListener('keyup', event => event.code.toUpperCase() === 'ESCAPE' && this.close());

    swipedetect(this, function(swipedir){
      if(swipedir=='right'){
        this.close();
      }
    }.bind(this))
  }

  connectedCallback(){
    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', this.open.bind(this))
    })
  }

  disconnectedCallback() {
  }

  open(event) {
    this.customEventBeforeOpen(event);

    document.body.classList.add('cart-drawer--open');
    document.disablePageScroll();
    this.setAttribute('open', true);

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.removeAttribute('open');
    document.enablePageScroll();
    document.body.classList.remove('cart-drawer--open');

    document.body.removeEventListener('click', this.onBodyClick);
  }

  handleBodyClick(event) {
    const target = event.target;
    if (!target.closest('.common-drawer-hard') && !target.closest('.common-drawer-trigger')) {
      this.close();
    }
  }

  customEventBeforeOpen(event){
    const target = event.currentTarget;

    if(target.classList.contains('product__feature')){
      this.productFeaturesDrawerContent(target);
      return;
    }
  }

  /* functions of specific instances */
  productFeaturesDrawerContent(target){
    if(this.contentLoadedOnce) return;
    const triggerWrapper = target.closest('.product__features');
    this.contentWrapper.insertAdjacentHTML('beforeend', triggerWrapper.innerHTML);
    this.contentLoadedOnce = true;
  }
  /* end functions of specific instances */
}

customElements.define('common-drawer', CommonDrawer);